interface DPassLogoProps {
  className?: string;
}

export function DPassLogo({ className = "w-9 h-9" }: DPassLogoProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="D-Pass Logo"
    >
      {/* Main background */}
      <rect width="36" height="36" rx="9" fill="#059669" />
      {/* Passport book stacked pages */}
      <rect x="12" y="5"  width="16" height="22" rx="2.5" fill="rgba(255,255,255,0.10)" />
      <rect x="10" y="7"  width="16" height="22" rx="2.5" fill="rgba(255,255,255,0.12)" />
      <rect x="8"  y="9"  width="16" height="22" rx="2.5" fill="rgba(255,255,255,0.18)" />
      {/* D letterform on the front page */}
      <path
        d="M10 14.5h7.5c2.76 0 5 2.24 5 5s-2.24 5-5 5H10V14.5z"
        fill="white"
      />
      {/* D inner cutout */}
      <path
        d="M13 17.5h4.5c1.1 0 2 .9 2 2s-.9 2-2 2H13V17.5z"
        fill="#059669"
      />
      {/* Subtle top rule on front page */}
      <rect x="10" y="12" width="12" height="1.5" rx="0.75" fill="rgba(255,255,255,0.5)" />
    </svg>
  );
}
